import {logHandledError} from '../../services/errors/errorReporting';
import {startPerfTimer} from '../datadog/profiler';
import {fnv1a64} from './fnv';

export function getCacheStorageKey(namespace: string, key: any): string | null {
  if (key == null) {
    return null;
  }
  const stringified = JSON.stringify(key);

  const hash = fnv1a64(`${namespace}--${stringified}`);

  return `${hash}.json`;
}
export async function logPerfAndErrors<T>(
  operationName: string,
  fn: () => Promise<T>,
  namespace: string,
  context?: Record<string, any>
): Promise<T | void> {
  const {endPerfTimer} = startPerfTimer(operationName, context);
  try {
    const result = await fn();
    return result;
  } catch (err: any) {
    const errMsg = `[${namespace}: ${operationName}] Error - ${err}`;
    logHandledError(errMsg);
    console.error(errMsg);
  } finally {
    endPerfTimer();
  }
}
